import styled from 'styled-components'

export const TeamsDashboard = styled.div`
	margin: 0px 0 60px;
`
